import { render, staticRenderFns } from "./CustomChoiceElement.vue?vue&type=template&id=59b40ab0&scoped=true&"
import script from "./CustomChoiceElement.vue?vue&type=script&lang=ts&"
export * from "./CustomChoiceElement.vue?vue&type=script&lang=ts&"
import style0 from "./CustomChoiceElement.vue?vue&type=style&index=0&id=59b40ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b40ab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('59b40ab0', component.options)
    } else {
      api.reload('59b40ab0', component.options)
    }
    module.hot.accept("./CustomChoiceElement.vue?vue&type=template&id=59b40ab0&scoped=true&", function () {
      api.rerender('59b40ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/forms/CustomChoiceElement.vue"
export default component.exports